/**
 * 权限
 * @param {权限值} key
 * @returns
 */
function permissionCheck (key) {
  const arr = ['1', '2', '3', '4']
  const index = arr.indexOf(key)
  if (index > -1) {
    return true // 有权限
  } else {
    return false // 无权限
  }
}
/**
 * 触屏的事件处理类
 */
class VueTouch {
  /**
   * @param el
   * @param binding
   * @param type
   */
  constructor (el, binding, type) {
    const g = this
    g.obj = el
    g.binding = binding
    g.touchType = type
    g.firstTouchPosition = { x: 0, y: 0 }
    g.firstTouchTime = 0
    g.callBack = typeof (binding.value) === 'object' ? binding.value.fn : binding.value
    g.moved = false
    g.leaved = false
    g.longTouched = false
    // 事件监听回调集合
    const _listener = Object.create(null)
    // 事件方法
    const _listen = (type) => {
      return function (e) {
        const { stop, prevent, self, once } = g.binding.modifiers
        // 配置判断
        if (stop) e.stopPropagation()
        if (prevent) e.preventDefault()
        if (once) g.obj.removeEventListener('touch' + type, _listener[type])
        if (self && e.target !== e.currentTarget) return
        g[type](e)
      }
    }
    _listener.start = _listen('start')
    _listener.end = _listen('end')
    _listener.move = _listen('move')
    this.obj.addEventListener('touchstart', _listener.start, false)
    this.obj.addEventListener('touchend', _listener.end, false)
    this.obj.addEventListener('touchmove', _listener.move, false)
  }

  start (e) {
    const g = this
    // 初始化点击状态
    g.moved = false
    g.leaved = false
    g.longTouched = false
    g.firstTouchPosition = g.getMultiCenter(e.changedTouches)
    g.firstTouchTime = e.timeStamp
    g.time = setTimeout(function () {
      if (!g.leaved && !g.moved) {
        g.touchType === 'longtap' && g.callBack(e, g.binding.value)
        g.longTouched = true
      }
    }, 200)
  }

  end (e) {
    const g = this
    const { x, y } = g.getMultiCenter(e.changedTouches)
    const _disX = x - g.firstTouchPosition.x
    const _disY = y - g.firstTouchPosition.y
    const _dis = Math.sqrt(_disX * _disX + _disY * _disY)
    const _timeDis = e.timeStamp - g.firstTouchTime
    clearTimeout(g.time)
    const _angle = this.getAngle(_disX, _disY)
    if (_dis > 18 && _timeDis < 300) {
      g.touchType === 'swipe' && g.callBack(e, g.binding.value)
      if (_angle >= 60 && _angle <= 120) { g.touchType === 'swipedown' && g.callBack(e, g.binding.value) }
      if (_angle <= -60 && _angle >= -120) { g.touchType === 'swipeup' && g.callBack(e, g.binding.value) }
      if (_angle <= 20 && _angle >= -20) { g.touchType === 'swipeleft' && g.callBack(e, g.binding.value) }
      if ((_angle <= -160 && _angle > -180) || (_angle >= 160 && _angle <= 180)) { g.touchType === 'swiperight' && g.callBack(e, g.binding.value) }
    } else {
      if (!g.longTouched && !g.moved) {
        g.touchType === 'tap' && g.callBack(e, g.binding.value)
        g.leaved = true
      }
    }
  }

  move () {
    this.moved = true
  }

  /**
   * 获取点击集合的中心坐标
   * @param touches touch对象集合
   * @return {{x: number, y: number}}
   */
  getMultiCenter (touches) {
    const g = this; let x = 0; let y = 0
    const _length = touches.length
    for (let i = 0; i < _length; i++) {
      x += touches[i].pageX
      y += touches[i].pageY
    }
    return {
      x: Math.round(x / _length),
      y: Math.round(y / _length)
    }
  };

  getAngle (disX, disY) {
    const g = this
    if (typeof disX !== 'number' || typeof disY !== 'number') { return 45 }
    return Math.atan2(disY, disX) * 180 / Math.PI
  }
}
export default {
  install (Vue) {
    // 按钮防抖（点击事件）
    Vue.directive('throttling', {
      bind: (el, binding) => {
        const throttlingTime = el.getAttribute('time') || 500
        let timerB = null
        el.addEventListener('click', () => {
          if (!timerB) {
            binding.value()
            timerB = setTimeout(() => {
              clearTimeout(timerB)
              timerB = null
            }, throttlingTime)
          }
        })
      }
    })
    // 简单权限指令
    Vue.directive('permission-s', {
      inserted: function (el, binding) {
        const permission = binding.value // 获取指令的值
        if (permission) {
          const hasPermission = permissionCheck(permission)
          if (!hasPermission) {
            // 没有权限 移除Dom元素
            el.parentNode && el.parentNode.removeChild(el)
          }
        }
      }
    })
    // 触屏点击事件
    Vue.directive('tap', {
      bind: function (el, binding) {
        new VueTouch(el, binding, 'tap')
      }
    })
    // 触屏长按事件
    Vue.directive('longtap', {
      bind: function (el, binding) {
        new VueTouch(el, binding, 'longtap')
      }
    })
  }
}
